<template>
  <div>
    <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h4 mr-r10 vertical-center-box">적용 템플릿 목록</div>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" :disabled="checkedRows.length === 0" @click="onClickReleaseButton">해제</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-row>
      <el-table-wrapper :data="targetTmplList" :columns="tableColumns" :column-default="columnDefault" ref="selectedObjTable"
        :pagination="true" :show-search-tool="showSearchTool" :show-custom-header="true" @selection-change="changeCheckedRow">
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WAgentSelectedObjTable',
  props: {
    targetTmplList: Array,
    originTargetTmplIds: Array,
  },
  watch: {
    targetTmplList() {
      this.checkChangetargetTmplList();
    },
  },
  data() {
    const tableColumns = [
      {
        align: 'center',
        type: 'selection',
        width: 40,
      },
      {
        prop: 'vmName',
        label: '템플릿명',
        width: '100',
        searchable: true,
        sortable: true,
        formatter: defaultFormatter,
      },
      {
        prop: 'hypervisorTypeName',
        label: '하이퍼바이저',
        width: '100',
        searchable: true,
        sortable: true,
        formatter: defaultFormatter,
      },
      {
        prop: 'virtualcenterName',
        label: '가상화센터명',
        width: '100',
        searchable: true,
        sortable: true,
        formatter: defaultFormatter,
      },
      {
        prop: 'osName',
        label: '운영체제',
        searchable: true,
        sortable: true,
        formatter: defaultFormatter,
      },
    ];
    return {
      checkedObjIds: [],
      changetargetTmplListFlag: false,
      columnDefault,
      showSearchTool: false,
      checkedRows: [],
      tableColumns,
    };
  },
  methods: {
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
    onClickReleaseButton() {
      this.checkedRows.forEach((row) => {
        this.targetTmplList.splice(this.targetTmplList.indexOf(row), 1);
      });
      this.$emit('reload-obj-list');
    },
    onClickCancelButton() {
      this.$emit('load-data');
    },
    checkChangetargetTmplList() {
      const checkedObjIds = [];
      this.targetTmplList.forEach((obj) => {
        if (!checkedObjIds.includes(obj.objId)) {
          checkedObjIds.push(obj.objId);
        }
      });
      checkedObjIds.sort((a, b) => (a - b));
      this.checkedObjIds = checkedObjIds;
      this.changetargetTmplListFlag = !isEqual(checkedObjIds, this.originTargetTmplIds);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/VirtualService/ServerImageSetting/popup/components/TargetTemplateListTable.vue